/**
 * Created by Ivan on 07.07.2026
 */

const RewardStickerView = function (sticker) {
    return Prefab.instantiate(bundles.stickers_reward_window.jsons.reward_sticker_prefab_json, { sticker });
};
